import { object } from './type-checkers.js';
const mapper = object
    .type('mapper');
export { mapper, };
//# sourceMappingURL=mapper.js.map